import { render, staticRenderFns } from "./EditUserModal.vue?vue&type=template&id=63a85224&scoped=true"
import script from "./EditUserModal.vue?vue&type=script&lang=ts"
export * from "./EditUserModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a85224",
  null
  
)

export default component.exports